import { PropTypes } from 'prop-types'
import { AreaSpeedLimitVehicleTypes } from '../../models/areas/area-speed-limit-vehicle-types-enum'

const { BUS, CAR, TRUCK } = AreaSpeedLimitVehicleTypes

export const areaSpeedProfilePropType = PropTypes.shape({
    speedLimit: PropTypes.number,
    vehicleType: PropTypes.oneOf([BUS, CAR, TRUCK])
})
